import { h } from '@atomify/jsx';
import { Image } from '@atoms/image/image';

const MapSwitchToggle = ({
    label,
    image,
    className,
}: {
    label: string;
    image: string;
    className: string;
}) => {
    return (
        <span class={className}>
            <span class="map-switch__toggle-label">{label}</span>

            <Image
                classes="map-switch__toggle-image"
                image={image}
                alt="Map switch toggle image"
                objectFit={true}
                settings={{
                    '640w': {
                        width: 200,
                        height: 200,
                    },
                }}
            />
        </span>
    );
};

export default MapSwitchToggle;
